module.exports = __webpack_public_path__ + "img/big_flug_active.889463e2.svg";